import { Injectable } from '@angular/core';
import { SplitFactory } from '@splitsoftware/splitio';
import { EMPTY, fromEvent, Subscription } from 'rxjs';
import { APP_CONFIG } from '../config/app.config';

@Injectable({
  providedIn: 'root',
})
export class SplitService {
  splitio: SplitIO.ISDK | undefined;
  splitClient: SplitIO.IClient = {} as any;
  isReady = false;
  subscription = new Subscription();

  constructor() {}

  isTreatmentOn(treatmentName: string): boolean {
    const treatment = this.splitClient.getTreatment(treatmentName);
    const result = treatment === 'on';

    return result;
  }

  initSdk(): void {
    this.splitio = SplitFactory({
      core: {
        authorizationKey: APP_CONFIG.split.key,
        key: 'customer-care',
      },
    });

    this.splitClient = this.splitio.client();
    this.verifyReady();
  }

  private verifyReady(): void {
    const isReadyEvent = fromEvent(this.splitClient, this.splitClient?.Event.SDK_READY);

    this.subscription = isReadyEvent.subscribe({
      next: res => {
        this.isReady = true;
      },
      error: err => {        
        this.isReady = false;
      },
    });
  }
}
